import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const termConditionApi = {
  getTermCondition: async () => {
    try {
      const url = `${API_ENDPOINTS.TERMS_CONDITIONS}`;
      const response = await apiClient.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching Term Condition:', error);
      throw error;
    }
  },

  createTermCondition: async (data) => {
    try {
      const url = `${API_ENDPOINTS.TERMS_CONDITIONS}`;
      const response = await apiClient.post(url, data);
      return response.data;
    } catch (error) {
      console.error('Error creating Term Condition:', error);
      throw error;
    }
  },

  updateTermCondition: async (data) => {
    try {
      const url = `${API_ENDPOINTS.TERMS_CONDITIONS}`;
      const response = await apiClient.put(url, data);
      return response.data;
    } catch (error) {
      console.error('Error updating Term Condition:', error);
      throw error;
    }
  },
};

export default termConditionApi;